import _Object$freeze from "@babel/runtime-corejs3/core-js/object/freeze";
export default {
  yes: _Object$freeze({
    TKThirdPartyInfo: true,
    TKStagesNews: true,
    TKKnotNews: true,
    TKNewsflashNews: true,
    TKKnotShopNews: true
  }),
  no: _Object$freeze({
    TKThirdPartyInfo: false,
    TKStagesNews: false,
    TKKnotNews: false,
    TKNewsflashNews: false,
    TKKnotShopNews: false
  })
};